<template>
  <div class="container-item gallery">
    <div class="row justify-content-center">
      <div class="col-md-12 col-lg-8 col-xl-7 col-12 p-0">
        <div class="uno-image">
          <imageElement :imageData="imageDataScroll(items[0])" :position="items[0].position" />          
        </div>
        <div class="dos-image">
          <imageElement :imageData="imageDataScroll(items[1])"  :position="items[1].position" />          
        </div>
        <div class="tres-image">
          <imageElement :imageData="imageDataScroll(items[2])" :position="items[2].position" />          
        </div>
      </div>
      <div class="col-md-11 col-lg-8 col-xl-7 col-12">
        <div v-if="items[0].imageCredits" class="text-left creditos-picture">
          {{ items[0].imageCredits }}
        </div>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-md-12 col-lg-8 col-xl-7 col-12">
        <div class="mt-3" style="color: #FF5A34;" v-if="items[0].text">{{ items[0].text }}</div>
      </div>
    </div>   
  </div>
</template>

<script>

import images from '@/mixins/images'

export default {
  name: 'SplitScroll',
  mixins: [images],
  props: {
    items: Array
  }
}
</script>
